module.exports = __webpack_public_path__ + "assets/images/fc18c71d3d86e1f35c34487d4621b009.svg";